"use client";

import { useMemo } from "react";
import { dateDifference } from "@/src/shared/utils/timeFunctionsModel";

interface IUseDateDifferenceProps {
  checkIn?: Date | string | null;
  checkOut?: Date | string | null;
}

const useDateDifference = ({
  checkIn,
  checkOut,
}: IUseDateDifferenceProps = {}): number => {
  const checkInDate = checkIn;
  const checkOutDate = checkOut;

  const differenceInDays = useMemo(() => {
    if (!checkInDate || !checkOutDate) return 0;

    return dateDifference(checkInDate, checkOutDate);
  }, [checkInDate, checkOutDate]);

  return differenceInDays;
};

export default useDateDifference;
